// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/vip.twh.frbe.scss';

// i18n
import i18n from '../../i18n/fr-BE';

import vip from './vip';

vip(i18n);
